import { type MonthYearRange } from '@vy/ui-design-system';
import { vyDate } from '@vy/utils';

export function toMonthYearRange(
  fromDate: Date | null,
  toDate: Date | null,
): MonthYearRange {
  return [
    fromDate ? vyDate(fromDate) : null,
    toDate ? vyDate(toDate) : null,
  ];
}

export function splitMonthYearRange(range: MonthYearRange): {
  fromDate: Date | null;
  toDate: Date | null;
} {
  const [start, end] = range;
  return {
    fromDate: start ? vyDate(start, { keepLocalTime: true }).startOf('month').toDate() : null,
    toDate: end ? vyDate(end, { keepLocalTime: true }).startOf('month').toDate() : null,
  };
}
